export default "__VITE_ASSET__DXA8udE7__"